[
  {
    "id": 5066,
    "uuid": "26bb655c-a503-40ff-98da-4eba9fc229a2",
    "hitokoto": "每个人的生命都由秒来计算，因为你永远都不知道下一秒会发生什么。",
    "type": "l",
    "from": "网易云热评",
    "from_who": null,
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581833771",
    "length": 31
  },
  {
    "id": 7027,
    "uuid": "816300ab-19ee-4034-b607-eb033a7966ec",
    "hitokoto": "一朝耍流氓，十年挂南墙；不乖的孩子统统都要打屁股；越狱是不可能越狱的，这辈子是不可能越狱的。",
    "type": "l",
    "from": "bilibili小黑屋",
    "from_who": null,
    "creator": "张一",
    "creator_uid": 5013,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613058468",
    "length": 46
  }
]